module.exports = "/images/legacy.svg?b2e7d81354fa21e0b39d4913ff1273f2";